import { createContext, useCallback, useContext, useState } from 'react';

const BottomNavContext = createContext({
  override: null,
  setOverride: () => {},
  clearOverride: () => {},
});

export function BottomNavProvider({ children }) {
  const [override, setOverrideState] = useState(null);

  // Wrap in () => to prevent React treating a function node as an updater
  const setOverride = useCallback((node) => {
    setOverrideState(() => node);
  }, []);

  const clearOverride = useCallback(() => {
    setOverrideState(null);
  }, []);

  return (
    <BottomNavContext.Provider value={{ override, setOverride, clearOverride }}>
      {children}
    </BottomNavContext.Provider>
  );
}

export function useBottomNav() {
  return useContext(BottomNavContext);
}

export default BottomNavContext;
